import { playdeck } from "../playdeck";
import { Locale, UserModel } from "../playdeck/types";
import { initializationDev } from "./dev-initialization";

const INITIALIZATION_TIMEOUT_MS = 10000;

export const initialization = (): Promise<UserModel> => {
  if (process.env.NODE_ENV === "development") {
    return initializationDev();
  }

  return initializationPlaydeck();
};

const initializationPlaydeck = (): Promise<UserModel> => {
  return new Promise((resolve, reject) => {
    const onMessage = ({ data }: MessageEvent) => {
      const pdData = data?.playdeck;
      if (!pdData) return;

      if (pdData.method === "getUserProfile" && pdData.value) {
        window.playdeckUser = pdData.value;
      }

      if (pdData.method === "getData") {
        const normalizedData = normalizePlaydeckData(pdData.value);
        if (normalizedData) {
          window.playdeckData = normalizedData;
        }
      }

      const resolvedUser = resolveUser();
      if (!resolvedUser) return;

      cleanup();
      resolve(resolvedUser);
    };

    const timeoutId = window.setTimeout(() => {
      cleanup();
      reject(new Error("Playdeck initialization timeout"));
    }, INITIALIZATION_TIMEOUT_MS);

    const cleanup = () => {
      window.removeEventListener("message", onMessage);
      window.clearTimeout(timeoutId);
    };

    window.addEventListener("message", onMessage);

    const resolvedUser = resolveUser();
    if (resolvedUser) {
      cleanup();
      resolve(resolvedUser);
      return;
    }

    playdeck.getUser();
    playdeck.getData("user");
    playdeck.setLoading();
  });
};

const normalizePlaydeckData = (
  data: unknown,
): Window["playdeckData"] | undefined => {
  if (!data || typeof data !== "object" || Array.isArray(data)) {
    return undefined;
  }

  const source = data as {
    data?: unknown;
    key?: unknown;
  };

  let normalizedData: { [key: string]: any } = {};
  if (typeof source.data === "string") {
    try {
      const parsed = JSON.parse(source.data);
      if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
        normalizedData = parsed;
      }
    } catch {
      normalizedData = {};
    }
  } else if (
    source.data &&
    typeof source.data === "object" &&
    !Array.isArray(source.data)
  ) {
    normalizedData = source.data as { [key: string]: any };
  }

  return {
    key: typeof source.key === "string" ? source.key : "user",
    data: normalizedData,
  };
};

const resolveUser = (): UserModel | undefined => {
  const playdeckUser = window.playdeckUser;
  const playdeckData = window.playdeckData;

  if (!playdeckUser?.telegramId || !playdeckData) {
    return undefined;
  }

  return {
    ...playdeckUser,
    locale: resolverLocale(playdeckUser.locale),
    data: playdeckData.data,
  };
};

const resolverLocale = (locale: string): Locale => {
  if (locale === "ru") return "ru";

  return "en";
};
